import { render, staticRenderFns } from "./RateTypeCreate.vue?vue&type=template&id=d4d32270&scoped=true&"
import script from "./RateTypeCreate.vue?vue&type=script&lang=js&"
export * from "./RateTypeCreate.vue?vue&type=script&lang=js&"
import style0 from "./RateTypeCreate.vue?vue&type=style&index=0&id=d4d32270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d32270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VCheckbox,VCol,VDataTable,VDialog,VRow,VTextField})
